import { queryOptions } from '@tanstack/react-query';
import { Domain, } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const ticketKeys = {
    all: ['tickets'],
    get: (filter, scope) => ['tickets', filter, scope],
};
export const ticketOptions = {
    get: (filter, scope) => queryOptions({
        queryKey: ticketKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.Ticket);
            return repo.get(filter, scope);
        },
    }),
    create: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.Ticket);
            return repo.create(request);
        },
    }),
    respond: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.Ticket);
            return repo.respond(request);
        },
    }),
};
